/**
 *
 */
import { ErrorMessage } from "components/Error/ErrorMessageComponent";
import { Input } from "components/Input/InputComponent";
import { RadioGroup } from "components/RadioGroup/RadioGroupComponent";
import { Footer } from "components/UI/Footer/FooterComponent";
import { PayButton } from "components/UI/PayButton/PayButtonComponent";
import { Select } from "components/UI/Select/SelectComponent";
import { ConfrontaValidation } from "components/WaitingView/ConfrontaValidationComponent";
import {
  getBankList,
  getTransferSubscriptionToken,
  setDirty,
  updateInput,
  updateRadioGroup,
  updateSelectValue,
} from "containers/TransferSubscriptions/store/ActionCreators";
import * as React from "react";
import {
  LocalizeContextProps,
  Translate,
  withLocalize,
} from "react-localize-redux";
import { connect } from "react-redux";
import { Col, Container, Row } from "reactstrap";
import { Dispatch } from "redux";
import { ThunkDispatch } from "redux-thunk";
import { BANK_TRANSLATION_CODES } from "root/shared/BankCatalogEnum";
import { sendParametersToParent } from "root/shared/Messenger";
import { PaymenMethodEnum } from "root/shared/PaymenMethodEnum";
import { PciImages } from "root/shared/PciImages";
import { calculateTotalAmount, checkValidity } from "root/shared/Utility";
import {
  CajitaStore,
  IInputProps,
  IRadioGroupProps,
  ISelectProps,
} from "root/store/CajitaStore";
import { ITransferSubscriptionFormProps } from "types/cajita_store";
import { ITransferAmount } from "types/transfer_amount";
import { ITransferSubscriptionActionCreator } from "types/transfer_subscription_action_creator";
import { TransferSubscriptionTokenRequest } from "types/transfer_subscription_token_request";

/**
 * Transfer subscription component
 */

class TransferSubscriptionComponent extends React.Component<
  ITransferSubscriptionFormProps & LocalizeContextProps
> {
  constructor(props: ITransferSubscriptionFormProps & LocalizeContextProps) {
    super(props);
    this.props.addTranslation(this.props.translation);
    this._inputHandler = this._inputHandler.bind(this);
    this._selectHandler = this._selectHandler.bind(this);
    this.__onRadioHandler = this.__onRadioHandler.bind(this);
    this._submitHandler = this._submitHandler.bind(this);
  }

  public componentDidMount(): void {
    this.props.getBankList(this.props.bankId.id);
  }

  public componentDidUpdate(): void {
    // istanbul ignore next
    if (this.props.token !== undefined && this.props.message === "BIO000")
      sendParametersToParent({
        token: this.props.token,
        paymentMethod: PaymenMethodEnum.TRANSFER_SUBSCRIPTION,
      });

    return;
  }

  public render(): React.ReactNode {
    return !this.props.isTransferSubscriptionAvailable ? (
      <div className={"container"}>
        <div className={"row text-center"}>
          <h4>
            <Translate id="notAvailableTransfer" />
          </h4>
        </div>
        <div className={"pseImage"} />
        <div className={"poweredBy"} />
      </div>
    ) : (
      <form onSubmit={this._submitHandler} autoComplete="off" noValidate={true}>
        <ErrorMessage />
        <ConfrontaValidation />
        <div id="box-details-pse">
          <Container className="custom-container" fluid={true}>
            <Row>
              <Col xs={12} style={{ marginTop: 8 }}>
                <Input
                  {...this.props.name}
                  change={this._inputHandler}
                  touched={this.props.onTouched}
                />
              </Col>
              <Col xs={12} style={{ paddingTop: 18 }}>
                <Input
                  {...this.props.lastName}
                  change={this._inputHandler}
                  touched={this.props.onTouched}
                />
              </Col>
            </Row>
          </Container>
        </div>
        <div>
          <Container className="custom-container" fluid={true}>
            <Row>
              <Col xs={3} sm={12} md={2} lg={2} xl={2} className="section">
                <Select
                  {...this.props.documentType}
                  change={this._selectHandler}
                  style={{ paddingLeft: 0 }}
                />
              </Col>
              <Col
                xs={9}
                sm={12}
                md={10}
                lg={10}
                xl={10}
                style={{ paddingLeft: 0 }}
              >
                <Input
                  {...this.props.documentNumber}
                  change={this._inputHandler}
                  touched={this.props.onTouched}
                />
              </Col>
            </Row>
          </Container>
        </div>
        <Select
          {...this.props.bankId}
          change={this._selectHandler}
          translationTargets={BANK_TRANSLATION_CODES}
        />
        <div>
          <Container className="custom-container-radio-group" fluid={true}>
            <Row>
              <Col
                xs={5}
                sm={6}
                md={6}
                lg={6}
                xl={6}
                className="d-flex align-items-center"
              >
                <div className="transfer-subscription-account-label-container">
                  <span className="pse-label toggle-left transfer-subscription-account-label">
                    <Translate id="accountTypeLabel" />
                  </span>
                </div>
              </Col>
              <Col
                xs={7}
                sm={6}
                md={6}
                lg={6}
                xl={6}
                style={{ margin: "auto" }}
              >
                <div className={"shared-div"}>
                  <RadioGroup
                    {...this.props.accountType}
                    clicked={this.__onRadioHandler}
                  />
                </div>
              </Col>
            </Row>
          </Container>
        </div>

        <div id="box-details-pse">
          <Input
            {...this.props.accountNumber}
            change={this._inputHandler}
            touched={this.props.onTouched}
          />
          <Input
            {...this.props.email}
            change={this._inputHandler}
            touched={this.props.onTouched}
          />
        </div>
        <PayButton
          isValid={this.props.isValid}
          totalAmount={this.props.amount}
          isSubscription={true}
          currency={this.props.currency}
          disable={this.props.disablePayButton}
        />
        <Footer
          pciClass={PciImages.bancoBogotaImage}
          showLanguajeToggle={this.props.isLanguageToggleAvailable}
        />
      </form>
    );
  }

  private _selectHandler(id: string, newValue: string): void {
    const new_select: ISelectProps = { ...this.props[id] };

    new_select.value = newValue;
    this.props.onSelectChanged(new_select);
  }

  private __onRadioHandler(id: string, newSelected: string): void {
    const new_radio: IRadioGroupProps = { ...this.props[id] };

    new_radio.selected = newSelected;
    this.props.toggleAccountType(new_radio);
  }

  private _inputHandler(id: string, newValue: string): void {
    const new_input: IInputProps = { ...this.props[id] };

    new_input.rules.required = true;
    new_input.valid = checkValidity(newValue, new_input.rules);
    new_input.value = newValue;

    this.props.onChangeInput(new_input);
  }

  private _submitHandler(event: React.FormEvent<HTMLFormElement>): void {
    event.preventDefault();

    this.props.tokens({
      accountType: this.props.accountType.selected,
      accountNumber: this.props.accountNumber.value,
      documentType: this.props.documentType.value,
      documentNumber: this.props.documentNumber.value,
      currency: this.props.currency,
      totalAmount: this.props.amount,
      bankCode: this.props.bankId.value,
      name: this.props.name.value,
      lastName: this.props.lastName.value,
      email: this.props.email.value,
    });
  }
}

const mapDispatchToProps: (dispatch: Dispatch) => object = (
  dispatch: ThunkDispatch<
    CajitaStore,
    undefined,
    ITransferSubscriptionActionCreator
  >
): object => ({
  onChangeInput: (payload: IInputProps): void => dispatch(updateInput(payload)),
  onTouched: (payload: IInputProps): ITransferSubscriptionActionCreator =>
    dispatch(setDirty(payload)),
  onSelectChanged: (payload: ISelectProps): void =>
    dispatch(updateSelectValue(payload)),
  toggleAccountType: (
    payload: IRadioGroupProps
  ): ITransferSubscriptionActionCreator => dispatch(updateRadioGroup(payload)),
  tokens: (payload: TransferSubscriptionTokenRequest): void =>
    dispatch(getTransferSubscriptionToken(payload)),
  getBankList: (id: string): void => dispatch(getBankList(id)),
});

const mapStateToProps: (
  state: CajitaStore
) => ITransferSubscriptionFormProps = (
  state: CajitaStore
): ITransferSubscriptionFormProps => ({
  ...state.transferSubscriptions,
  amount: calculateTotalAmount(state.config.amount as ITransferAmount),
  isLanguageToggleAvailable: true,
  currency: state.config.currency,
  disablePayButton: state.config.disablePayButton,
});

const TransferSubscription: React.ComponentClass = connect(
  mapStateToProps,
  mapDispatchToProps
)(
  withLocalize<ITransferSubscriptionFormProps & LocalizeContextProps>(
    TransferSubscriptionComponent
  )
);

export { TransferSubscription };



// WEBPACK FOOTER //
// ./src/containers/TransferSubscriptions/TransferSubscriptionComponent.tsx